import React, { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Callout } from '@node-space/ui-components'
import { MappedErrorMessage, MappedErrorMessageProps } from './MappedErrorMessage'

export interface RequestErrorProps extends MappedErrorMessageProps {
  children?: ReactNode
  sentryTraceId?: string
}

export const RequestError = ({
  children,
  errorCode,
  fallbackMessage,
  sentryTraceId,
}: RequestErrorProps) => {
  const { t } = useTranslation()

  const isHandledErrorMessage = !!children
  const errorMessage = isHandledErrorMessage ? (
    children
  ) : (
    <MappedErrorMessage errorCode={errorCode} fallbackMessage={fallbackMessage} />
  )

  return (
    <Callout variant="error" testId="request-error-callout">
      <Box aria-label="Request error message">{errorMessage}</Box>
      {!!sentryTraceId && (
        <p className="text-body-regular-small text-foreground-subtle pt-2">
          {t('errorMessages.traceId')}: {sentryTraceId}
        </p>
      )}
    </Callout>
  )
}
